import { GalleryTypes } from '@customTypes/gallery';
import { galleryState as state } from './galleryState';
import { isDesktop } from '@utils/device';

export const galleryConfigure = () => {
  const rootElement: HTMLElement | null = document.querySelector('[data-gallery-init]');

  if (!rootElement) throw new Error(`gallery/galleryConfigure: init element not found`);

  const templateConfiguration = JSON.parse(
    rootElement.dataset.galleryInit as string
  ) as GalleryTypes.TemplateConfig;

  state.setConfiguration({ ...templateConfiguration, rootElement, isDesktop: isDesktop() });
};
